<template>
  <div class="not-implemented-widget card h-100">
    <div class="card-header">
      <h4 class="card-title">
        {{ $t('widgetNotImplemented.content') }}: {{ type }}
      </h4>
    </div>
    <div class="card-body"></div>
  </div>
</template>

<script>
export default {
  name: 'NotImplementedWidget',
  props: {
    type: String,
    data: Object
  }
}
</script>
